import React from "react";
import { useNavigate } from "react-router-dom";
import { Video, ArrowRight, Camera, Share2 } from "lucide-react";
import NicheComTag from "./NicheComTag";

function Ring({ pct }) {
  const r = 34, c = 2 * Math.PI * r, off = c * (1 - pct / 100);
  return (
    <div className="relative shrink-0" style={{ width: 84, height: 84 }}>
      <svg width="84" height="84">
        <circle cx="42" cy="42" r={r} fill="none" stroke="#EDEEE9" strokeWidth="7" />
        <circle cx="42" cy="42" r={r} fill="none" stroke="#93C020" strokeWidth="7" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={off} transform="rotate(-90 42 42)"
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(.16,1,.3,1)" }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center font-extrabold tabular-nums" style={{ fontSize: "19px", color: "#16180F" }}>{pct}%</div>
    </div>
  );
}

function Bar({ icon: Icon, label, pct, highlight }) {
  return (
    <div>
      <div className="flex items-center justify-between text-sm mb-1">
        <span className="inline-flex items-center gap-1.5 text-ink-2"><Icon size={13} strokeWidth={1.75} style={{ color: highlight ? "#5F8213" : "#9A9C90" }} />{label}</span>
        <span className="font-bold text-ink tabular-nums">{pct}%</span>
      </div>
      <div className="h-1.5 rounded-full overflow-hidden" style={{ background: "#EDEEE9" }}>
        <div className="h-full rounded-full transition-all duration-700" style={{ width: `${pct}%`, background: pct >= 70 ? "#93C020" : pct >= 50 ? "#B7CE5E" : "#E5A93D" }} />
      </div>
    </div>
  );
}

export default function NicheComUsageCard({ data }) {
  const navigate = useNavigate();
  if (!data?.enabled) return null;
  return (
    <div className="card p-6 h-full flex flex-col" data-testid="nichecom-usage-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2"><span className="label-caps">NicheCom Usage</span><NicheComTag /></div>
        <span className="text-xs text-ink-3">{data.assets_unused} assets unused</span>
      </div>
      <div className="flex items-center gap-5">
        <Ring pct={data.overall} />
        <div className="flex-1 space-y-2.5">
          <Bar icon={Video} label="Professional video" pct={data.video.used} highlight />
          <Bar icon={Camera} label="Photography" pct={data.photography.used} />
          <Bar icon={Share2} label="Social assets" pct={data.social.used} />
        </div>
      </div>
      <div className="mt-5 flex items-center justify-between gap-3 rounded-xl px-4 py-3" style={{ background: "var(--grad-green-soft)" }}>
        <span className="text-sm text-ink">Potential Growth Score: <span className="font-bold" style={{ color: "#5F8213" }}>+{data.potential_growth_gain}</span></span>
        <button className="btn-primary focus-ring !px-3.5 !py-2 !text-xs shrink-0" onClick={() => navigate("/app/nichecom")} data-testid="use-content-cta">
          Use content <ArrowRight size={14} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}
